import { dayjs, setupDayjs } from './dayjs-setup.js';
setupDayjs();
function nowUtc() {
    const dj = dayjs;
    return dj.utc ? dj.utc() : dayjs();
}
function resolvePreset(preset) {
    const map = {
        today: 'today',
        '7d': '7d',
        '30d': '30d',
        last7: '7d',
        last30: '30d',
        week: 'week',
        month: 'month',
        quarter: 'quarter',
        lastQuarter: 'quarter',
        thisWeek: 'week',
        thisMonth: 'month',
        thisQuarter: 'quarter',
    };
    return map[preset];
}
function quarterBounds(ref) {
    const month = ref.month();
    const qStartMonth = Math.floor(month / 3) * 3; // 0,3,6,9
    const from = ref.clone().month(qStartMonth).startOf('month');
    const to = ref.clone().month(qStartMonth + 2).endOf('month');
    return { from, to };
}
/**
 * Returns a UTC-normalized Dayjs range for a preset.
 * from is at 00:00:00.000Z; to is at 23:59:59.999Z
 */
export function getPresetRange(preset) {
    // Handle explicit relative period presets that aren't simple aliases
    if (preset === 'lastQuarter') {
        const ref = nowUtc().subtract(3, 'month');
        return quarterBounds(ref);
    }
    const p = resolvePreset(preset);
    const now = nowUtc();
    if (p === 'today') {
        return { from: now.startOf('day'), to: now.endOf('day') };
    }
    if (p === '7d') {
        return { from: now.subtract(6, 'day').startOf('day'), to: now.endOf('day') };
    }
    if (p === '30d') {
        return { from: now.subtract(29, 'day').startOf('day'), to: now.endOf('day') };
    }
    if (p === 'week') {
        return { from: now.startOf('week'), to: now.endOf('week') };
    }
    if (p === 'month') {
        return { from: now.startOf('month'), to: now.endOf('month') };
    }
    // quarter
    return quarterBounds(now);
}
/** Returns ISO strings for the UTC-normalized preset range. */
export function getPresetRangeIso(preset) {
    const { from, to } = getPresetRange(preset);
    return { from: from.toISOString(), to: to.toISOString() };
}
/** Clamp a range to a maximum number of days. */
export function clampRangeMaxDays(range, maxDays = 186) {
    const { from, to } = range;
    const diffDays = to.diff(from, 'day');
    if (diffDays <= maxDays)
        return { range, clamped: false };
    const dj = dayjs;
    const toUtc = dj.utc ? dj.utc(to) : to;
    const newFrom = toUtc.subtract(maxDays, 'day').startOf('day');
    return { range: { from: newFrom, to }, clamped: true };
}
//# sourceMappingURL=presets.js.map